import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import expand from '../assets/images/expand-peach.svg';
import close from '../assets/images/close-expanded-peach.svg';
import { tr } from '../utils/translations';
import LocaleContext from './LocaleContext';
import { breakpoints } from '../styles/Variables';

const VimeoStyles = styled.div`
  position: relative;
  padding-bottom: ${(props) => props.heightRatio};
  overflow: hidden;
  max-width: 100%;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .heroText {
    position: absolute;
    left: 0;
    top: 50%;
    font-size: clamp(2.5rem, 6vw, var(--fsHero));
    margin-top: -3vw;
    text-align: center;
    width: 100%;
    color: var(--peach);
    font-family: Albertus, serif;
  }

  .toggleExpanded {
    position: absolute;
    z-index: 1;
    top: 1rem;
    right: 1rem;
    background-color: transparent;
    background-repeat: no-repeat;
    background-size: contain;
    border: none;
    text-indent: -9999px;
    width: 2rem;
    height: 2rem;
    cursor: pointer;
    transition: all 0.5s;
    outline: none;
    background-image: url(${expand});
    border-radius: 0;
    display: none;

    @media (max-width: ${breakpoints.breakMd}) {
      display: block;
    }
  }

  .notice {
    display: none; // Show in expanded mode
    position: absolute;
    width: 100%;
    left: 0;
    top: var(--col2);
    font-family: Avenir, sans-serif;
    text-align: center;
    color: var(--peach);
  }

  @media (max-width: ${breakpoints.breakMd}) {
    &.expanded {
      margin-bottom: 100vh; // To avoid losing scroll position
      z-index: 10;
      position: fixed;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: black;

      .toggleExpanded {
        position: fixed;
        z-index: 10;
        background-image: url(${close});
      }

      .notice {
        display: block;

        @media (orientation: landscape) {
          display: none;
        }
      }
    }
  }
`;

const HandleToggleExpanded = (expanded, setExpanded) => {
  if (expanded) {
    document.body.classList.remove('expanded');
  } else {
    document.body.classList.add('expanded');
  }
  setExpanded(!expanded);
};

// heightRatio = percent of width to achieve correct aspect ratio (default 66%)
export default function Vimeo({
  vimeoID,
  heightRatio,
  heroText,
  className,
  controls,
  autoplay = false,
  allowExpand,
}) {
  const [expanded, setExpanded] = useState(false);
  const [locale, setLocale] = useContext(LocaleContext);

  if (!vimeoID) return null;
  const urlSeparator = `${vimeoID}`.includes('?') ? '&' : '?';

  let vimeoURL = `https://player.vimeo.com/video/${vimeoID}`;
  if (autoplay) {
    vimeoURL = `https://player.vimeo.com/video/${vimeoID}${urlSeparator}autoplay=1&muted=1`;
  }
  if (!controls) {
    vimeoURL = `https://player.vimeo.com/video/${vimeoID}${urlSeparator}autoplay=1&loop=1&background=1`;
  }

  return (
    <VimeoStyles
      heightRatio={heightRatio ? `${heightRatio}%` : '66%'}
      className={
        expanded ? `vimeo expanded ${className}` : `vimeo ${className}`
      }
    >
      <iframe title={vimeoID} src={vimeoURL} frameBorder="0" allowFullScreen />
      {heroText && (
        <h3 data-sal="fade" data-sal-duration="1500" className="heroText">
          {heroText}
        </h3>
      )}
      {allowExpand && (
        <>
          <button
            type="button"
            className="toggleExpanded"
            onClick={() => HandleToggleExpanded(expanded, setExpanded)}
          >
            {expanded ? 'Close' : 'Expand'}
          </button>
          <div className="notice">
            {tr('cta', 'turnPhoneHorizontal', locale)}
          </div>
        </>
      )}
    </VimeoStyles>
  );
}
